import React from 'react';
export var WixStyleReactEnvironmentContext = /*#__PURE__*/React.createContext({});